import { z } from 'zod'
import {
  KmSchema,
  SignalSchema,
  ZugmeldestelleSchema
} from '../../Generic/schema/generic.schema'

export const Auftrag1_10ZeileTypes = {
  KM: 'km',
  SIGNAL_ZUGMELDESTELLE: 'signal_zugmeldestelle'
} as const

export type Auftrag1_10ZeileType =
  (typeof Auftrag1_10ZeileTypes)[keyof typeof Auftrag1_10ZeileTypes]

export const Auftrag1_10ZeileSchema = z.object({
  type: z.enum(['', 'km', 'signal_zugmeldestelle']).default(''),
  km: KmSchema,
  signal: SignalSchema,
  zugmeldestelle: ZugmeldestelleSchema
})

export type Auftrag1_10ZeileData = z.infer<typeof Auftrag1_10ZeileSchema>

export const DEFAULT_AUFTRAG1_10_ZEILE: Auftrag1_10ZeileData = {
  type: '',
  km: '',
  signal: '',
  zugmeldestelle: {
    art: '' as const,
    name: ''
  }
}
